import { type MCPServerInfo } from '../../types';

const HarnessServer: MCPServerInfo = {
  serverId: 'HARNESS',
  name: 'Harness',
  slug: 'harness',
  description: 'Interact with Harness services over the Harness API.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/harness:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [
      'harness_api_key',
      'harness_default_org_id',
      'harness_default_project_id',
      'harness_base_url'
    ],
    properties: {
      harness_api_key: {
        type: 'string',
        description: 'Harness API Key',
        sensitive: true
      },
      harness_default_org_id: {
        type: 'string',
        description: 'Default Organization ID for Harness',
        sensitive: false
      },
      harness_default_project_id: {
        type: 'string',
        description: 'Default Project ID for Harness',
        sensitive: false
      },
      harness_base_url: {
        type: 'string',
        description: 'Base URL for Harness API',
        sensitive: false
      }
    }
  }
};

export default HarnessServer;
